"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const customElement_1 = tslib_1.__importDefault(require("../../../lib/customElement"));
class TriangleKey extends customElement_1.default {
    constructor() {
        super(...arguments);
        this.STYLE = `
        <style>
            .container {
                width: calc(var(--increment-amount) * var(--border-size) * 6);
                height: calc(var(--increment-amount) * var(--border-size) * 6);
            }
            
            svg {
                width: 90%;
                height: 90%;
                transform: rotate(180deg);
                fill: #D2D2D2;
                stroke-width: 8;
                stroke: black;
            }
        </style>
    `;
        this.TEMPLATE = `
        <div class="container">
            <svg id="triangle" stroke-width="2" viewBox="0 0 100 100">
                <title>Upside Down Triangle Key</title>
                <polygon points="50 15, 100 100, 0 100"/>
            </svg>
        </div>   
    `;
    }
}
exports.default = TriangleKey;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJpYW5nbGVLZXkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9rZXlzL3RyaWFuZ2xlS2V5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHVGQUF1RDtBQUV2RCxNQUFxQixXQUFZLFNBQVEsdUJBQWE7SUFBdEQ7O1FBQ3VCLFVBQUssR0FBRzs7Ozs7Ozs7Ozs7Ozs7OztLQWdCMUIsQ0FBQztRQUVpQixhQUFRLEdBQUc7Ozs7Ozs7S0FPN0IsQ0FBQztJQUNOLENBQUM7Q0FBQTtBQTNCRCw4QkEyQkMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgQ3VzdG9tRWxlbWVudCBmcm9tIFwiLi4vLi4vLi4vbGliL2N1c3RvbUVsZW1lbnRcIjtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgVHJpYW5nbGVLZXkgZXh0ZW5kcyBDdXN0b21FbGVtZW50IHtcbiAgICBwcm90ZWN0ZWQgcmVhZG9ubHkgU1RZTEUgPSBgXG4gICAgICAgIDxzdHlsZT5cbiAgICAgICAgICAgIC5jb250YWluZXIge1xuICAgICAgICAgICAgICAgIHdpZHRoOiBjYWxjKHZhcigtLWluY3JlbWVudC1hbW91bnQpICogdmFyKC0tYm9yZGVyLXNpemUpICogNik7XG4gICAgICAgICAgICAgICAgaGVpZ2h0OiBjYWxjKHZhcigtLWluY3JlbWVudC1hbW91bnQpICogdmFyKC0tYm9yZGVyLXNpemUpICogNik7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBcbiAgICAgICAgICAgIHN2ZyB7XG4gICAgICAgICAgICAgICAgd2lkdGg6IDkwJTtcbiAgICAgICAgICAgICAgICBoZWlnaHQ6IDkwJTtcbiAgICAgICAgICAgICAgICB0cmFuc2Zvcm06IHJvdGF0ZSgxODBkZWcpO1xuICAgICAgICAgICAgICAgIGZpbGw6ICNEMkQyRDI7XG4gICAgICAgICAgICAgICAgc3Ryb2tlLXdpZHRoOiA4O1xuICAgICAgICAgICAgICAgIHN0cm9rZTogYmxhY2s7XG4gICAgICAgICAgICB9XG4gICAgICAgIDwvc3R5bGU+XG4gICAgYDtcblxuICAgIHByb3RlY3RlZCByZWFkb25seSBURU1QTEFURSA9IGBcbiAgICAgICAgPGRpdiBjbGFzcz1cImNvbnRhaW5lclwiPlxuICAgICAgICAgICAgPHN2ZyBpZD1cInRyaWFuZ2xlXCIgc3Ryb2tlLXdpZHRoPVwiMlwiIHZpZXdCb3g9XCIwIDAgMTAwIDEwMFwiPlxuICAgICAgICAgICAgICAgIDx0aXRsZT5VcHNpZGUgRG93biBUcmlhbmdsZSBLZXk8L3RpdGxlPlxuICAgICAgICAgICAgICAgIDxwb2x5Z29uIHBvaW50cz1cIjUwIDE1LCAxMDAgMTAwLCAwIDEwMFwiLz5cbiAgICAgICAgICAgIDwvc3ZnPlxuICAgICAgICA8L2Rpdj4gICBcbiAgICBgO1xufVxuIl19